(() => {
  const forms = document.querySelectorAll('[data-sperbs-sourcing-form]');

  forms.forEach((form) => {
    if (form.dataset.sperbsBound === 'true') return;
    form.dataset.sperbsBound = 'true';

    const endpoint = form.dataset.endpoint;
    const button = form.querySelector('[data-sperbs-form-submit]');
    const errorBox = form.querySelector('[data-sperbs-form-error]');
    const successBox = form.parentElement?.querySelector('[data-sperbs-form-success]');
    const initialButtonText = button?.textContent || 'Start My Search';
    const startedAt = Date.now();
    let submissionId = createSubmissionId();
    let sending = false;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (sending || !form.reportValidity()) return;

      hideError();
      sending = true;
      form.setAttribute('aria-busy', 'true');
      if (button) {
        button.disabled = true;
        button.textContent = 'Sending…';
      }

      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 12_000);
      const values = new FormData(form);

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            version: '1',
            submissionId,
            formType: 'sourcing_request',
            name: values.get('name') || '',
            email: values.get('email') || '',
            phone: values.get('phone') || '',
            brand: values.get('brand') || '',
            modelOrReference: values.get('modelOrReference') || '',
            desiredCondition: values.get('desiredCondition') || '',
            boxAndPapers: values.get('boxAndPapers') || '',
            budgetRange: values.get('budgetRange') || '',
            targetTimeline: values.get('targetTimeline') || '',
            notes: values.get('notes') || '',
            website: values.get('website') || '',
            startedAt,
            source: {
              url: window.location.href,
              referrer: document.referrer,
            },
          }),
          signal: controller.signal,
        });
        const result = await response.json().catch(() => ({}));

        if (response.status !== 202 || result.ok !== true) {
          throw new Error('The request was not accepted.');
        }

        form.hidden = true;
        if (successBox) {
          successBox.hidden = false;
          successBox.focus();
        }
      } catch (_error) {
        showError('We could not send your request. Your entries are still here—please try again or email Photos@sperbstimepieces.com.');
      } finally {
        window.clearTimeout(timeout);
        sending = false;
        form.removeAttribute('aria-busy');
        if (button) {
          button.disabled = false;
          button.textContent = initialButtonText;
        }
      }
    });

    function showError(message) {
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.hidden = false;
      errorBox.focus();
    }

    function hideError() {
      if (!errorBox) return;
      errorBox.hidden = true;
      errorBox.textContent = '';
    }

    function createSubmissionId() {
      if (window.crypto?.randomUUID) return window.crypto.randomUUID();
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
        const random = Math.floor(Math.random() * 16);
        const value = character === 'x' ? random : (random & 0x3) | 0x8;
        return value.toString(16);
      });
    }
  });
})();
